module.exports = __webpack_public_path__ + "static/media/sunpay.ea50b7d5.png";